import Vue from 'vue'
import axios from 'axios'
import { Loading } from 'element-ui'
import path from './port.js'
import router from '../../router'
const _this = new Vue()
console.log(_this, '_this')

// const baseURL = 'http://192.168.1.180:8090/control-gateway/' /* 曹 */
// const baseURL = 'http://192.168.1.60:8081/control-gateway/' /* 莫 */
// const baseURL = 'http://192.168.1.57:7080/control-gateway/' /* 徐兵 */
// const baseURL = 'http://192.168.1.181:8282/control-gateway/' /* 181测试 */
// const baseURL = 'http://192.168.1.183:8188/control-gateway/' /* 183测试 */
const baseURL = 'http://192.168.1.186:8188/control-gateway/' /* 186测试 */
// const baseURL = 'https://control.teamface.cn/control-gateway' /* 外网测试 */

// const baseURL2 = 'http://192.168.1.183:8081/custom-gateway/' /* 183测试 */
// const baseURL2 = 'http://192.168.1.181:8093/custom-gateway(New)/' /* 181测试 */
const baseURL2 = 'http://192.168.1.186:8081/custom-gateway/' /* 186测试 */
// const baseURL2 = 'https://file.teamface.cn/custom-gateway/' /* 外网测试 */

const options = {
  lock: true,
  text: 'Loading...',
  spinner: 'el-icon-loading',
  background: 'rgba(0, 0, 0, 0.4)'
}
/****
 * @params
 *  params //传递的数据
 *  url  //接口地址
 *  mask //遮罩层，不用遮罩层不用传或者false，若使用字符串用于文字显示，如 '保存中...'
 */
function ajaxGet (url, params, mask) {
  if (mask) {
    Loading.service(options)
  }
  let promise = new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: url,
      baseURL: baseURL,
      params: params,
      headers: JSON.parse(sessionStorage.requestHeader)
    })
      .then((res) => {
        if (mask) {
          let loadingInstance = Loading.service(options)
          _this.$nextTick(() => {
            loadingInstance.close()
          // console.log('关闭LOADING')
          })
        }
        if (res.data.response.code.toString() === '1001') {
          if (res.data.hasOwnProperty('identifier')) {
            console.log('进来关联映射')
            resolve(res.data)
          } else {
            resolve(res.data.data)
          }
        } else if (res.data.response.code === 1212) {
          _this.$message({
            showClose: true,
            message: '登录过期！',
            type: 'warning'
          })
          router.push({ path: '/' })
        } else {
          _this.$message({
            showClose: true,
            message: res.data.response.describe,
            type: 'error'
          })
          reject(res.response)
          console.log('请求失败，原因是：' + res.response.describe)
        }
      })
      .catch((err) => {
        let loadingInstance = Loading.service(options)
        _this.$nextTick(() => {
          loadingInstance.close()
        })
        reject(err)
        console.log(err)
      })
  })
  return promise
}
/****
 * @params
 *  data //传递的数据
 *  url  //接口地址
 *  mask //遮罩层，不用遮罩层不用传或者false，若使用字符串用于文字显示，如 '保存中...'
 */
function ajaxPost (url, data, mask) {
  if (mask !== false) {
    if (mask) {
      options.text = mask
    }
    Loading.service(options)
  }
  let promise = new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: url,
      baseURL: baseURL,
      data: data,
      headers: JSON.parse(sessionStorage.requestHeader)
    })
      .then((res) => {
        let loadingInstance = Loading.service(options)
        _this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close()
        })
        if (res.data.response.code.toString() === '1001') {
          resolve(res.data.data)
        } else if (res.data.response.code === 1212) {
          _this.$message({
            showClose: true,
            message: '登录过期！',
            type: 'warning'
          })
          router.push({ path: '/' })
        } else {
          _this.$message({
            showClose: true,
            message: res.data.response.describe,
            type: 'error'
          })
          reject(res.data.response)
        }
      })
      .catch((err) => {
        reject(err)
        let loadingInstance = Loading.service(options)
        _this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close()
        })
        console.log(err)
        _this.$message({
          showClose: true,
          message: '服务器错误',
          type: 'error'
        })
      })
  })
  return promise
}

function ajaxGetRequest (params, url) {
  return axios({
    method: 'get',
    url: url,
    baseURL: baseURL,
    params: params,
    headers: JSON.parse(sessionStorage.requestHeader)
  })
}
function ajaxPostRequest (data, url) {
  return axios({
    method: 'post',
    url: url,
    baseURL: baseURL,
    data: data,
    headers: JSON.parse(sessionStorage.requestHeader)
  })
}
// 具体接口
const HTTPServer = {
  login: function (params, mask) {
    return ajaxPost(path.login, params, mask)
  },
  imageUpload: function (params, mask) {
    return ajaxPost(path.imageUpload, params, mask)
  },
  commonUpload: function (params, mask) {
    return ajaxPost(path.commonUpload, params, mask)
  },

  /* ************************  客户管理  ***************************** */
  queryRegisterUserById: function (params, mask) {
    return ajaxGet(path.queryRegisterUserById, params, mask)
  },
  queryRegisterUserList: function (params, mask) {
    return ajaxGet(path.queryRegisterUserList, params, mask)
  },
  centerAdoptAccount: function (params, mask) {
    return ajaxPost(path.centerAdoptAccount, params, mask)
  },
  centerPullBlacklist: function (params, mask) {
    return ajaxPost(path.centerPullBlacklist, params, mask)
  },
  centerDelCompanyUser: function (params, mask) {
    return ajaxPost(path.centerDelCompanyUser, params, mask)
  },
  queryCommodityList: function (params, mask) {
    return ajaxGet(path.queryCommodityList, params, mask)
  },
  saveCommodityByUser: function (params, mask) {
    return ajaxPost(path.saveCommodityByUser, params, mask)
  },
  getDefaultCommodityList: function (params, mask) {
    return ajaxGet(path.getDefaultCommodityList, params, mask)
  },
  queryTrialUserList: function (params, mask) {
    return ajaxGet(path.queryTrialUserList, params, mask)
  },
  saveTrialUser: function (params, mask) {
    return ajaxPost(path.saveTrialUser, params, mask)
  },
  editTrialUser: function (params, mask) {
    return ajaxPost(path.editTrialUser, params, mask)
  },
  updateTrialCustomerUser: function (params, mask) {
    return ajaxPost(path.updateTrialCustomerUser, params, mask)
  },
  updateTrialToFormalUser: function (params, mask) {
    return ajaxPost(path.updateTrialToFormalUser, params, mask)
  },
  TenableDisableUser: function (params, mask) {
    return ajaxPost(path.TenableDisableUser, params, mask)
  },
  delTrialUser: function (params, mask) {
    return ajaxPost(path.delTrialUser, params, mask)
  },
  batchModifyTrialUser: function (params, mask) {
    return ajaxPost(path.batchModifyTrialUser, params, mask)
  },
  queryFormalUserList: function (params, mask) {
    return ajaxGet(path.queryFormalUserList, params, mask)
  },
  queryAllFormalUsers: function (params, mask) {
    return ajaxGet(path.queryAllFormalUsers, params, mask)
  },
  saveFormalUser: function (params, mask) {
    return ajaxPost(path.saveFormalUser, params, mask)
  },
  editFormalUser: function (params, mask) {
    return ajaxPost(path.editFormalUser, params, mask)
  },
  updateFormalUserCustomer: function (params, mask) {
    return ajaxPost(path.updateFormalUserCustomer, params, mask)
  },
  delFormalUser: function (params, mask) {
    return ajaxPost(path.delFormalUser, params, mask)
  },
  FenableDisableUser: function (params, mask) {
    return ajaxPost(path.FenableDisableUser, params, mask)
  },
  saveCustomerCommodity: function (params, mask) {
    return ajaxPost(path.saveCustomerCommodity, params, mask)
  },
  getCustomerCommodityList: function (params, mask) {
    return ajaxGet(path.getCustomerCommodityList, params, mask)
  },
  batchModifyFormalUser: function (params, mask) {
    return ajaxPost(path.batchModifyFormalUser, params, mask)
  },

  savaFormalUser: function (params, mask) {
    return ajaxPost(path.savaFormalUser, params, mask)
  },
  editFormalCompanyUser: function (params, mask) {
    return ajaxPost(path.editFormalCompanyUser, params, mask)
  },
  disableFormalCompanyUser: function (params, mask) {
    return ajaxPost(path.disableFormalCompanyUser, params, mask)
  },
  enableFormalCompanyUser: function (params, mask) {
    return ajaxPost(path.enableFormalCompanyUser, params, mask)
  },
  delFormalCompanyUser: function (params, mask) {
    return ajaxPost(path.delFormalCompanyUser, params, mask)
  },
  saveCustomerAuditRegulation: function (params, mask) {
    return ajaxPost(path.saveCustomerAuditRegulation, params, mask)
  },
  editCustomerAuditRegulation: function (params, mask) {
    return ajaxPost(path.editCustomerAuditRegulation, params, mask)
  },
  enableDisableCustomerAuditRegulation: function (params, mask) {
    return ajaxPost(path.enableDisableCustomerAuditRegulation, params, mask)
  },
  deleteCustomerAuditRegulation: function (params, mask) {
    return ajaxPost(path.deleteCustomerAuditRegulation, params, mask)
  },
  queryCustomerAuditRegulationList: function (params, mask) {
    return ajaxGet(path.queryCustomerAuditRegulationList, params, mask)
  },
  /* ************************  业务管理  ***************************** */
  saveAdditional: function (params, mask) {
    return ajaxPost(path.saveAdditional, params, mask)
  },
  queryAdditionalList: function (params, mask) {
    return ajaxGet(path.queryAdditionalList, params, mask)
  },
  delAdditional: function (params, mask) {
    return ajaxPost(path.delAdditional, params, mask)
  },
  queryAdditionalListByFormalUser: function (params, mask) {
    return ajaxGet(path.queryAdditionalListByFormalUser, params, mask)
  },
  queryAdditionalById: function (params, mask) {
    return ajaxGet(path.queryAdditionalById, params, mask)
  },
  saveReduction: function (params, mask) {
    return ajaxPost(path.saveReduction, params, mask)
  },
  queryReductionList: function (params, mask) {
    return ajaxGet(path.queryReductionList, params, mask)
  },
  delReduction: function (params, mask) {
    return ajaxPost(path.delReduction, params, mask)
  },
  queryReductionListByFormalUser: function (params, mask) {
    return ajaxGet(path.queryReductionListByFormalUser, params, mask)
  },
  saveRenewal: function (params, mask) {
    return ajaxPost(path.saveRenewal, params, mask)
  },
  editRenewal: function (params, mask) {
    return ajaxPost(path.editRenewal, params, mask)
  },
  delRenewal: function (params, mask) {
    return ajaxPost(path.delRenewal, params, mask)
  },
  queryRenewalList: function (params, mask) {
    return ajaxGet(path.queryRenewalList, params, mask)
  },
  queryRenewalListByFormalUser: function (params, mask) {
    return ajaxGet(path.queryRenewalListByFormalUser, params, mask)
  },
  queryRenewalOrderTimeList: function (params, mask) {
    return ajaxGet(path.queryRenewalOrderTimeList, params, mask)
  },
  getAllRenewList: function (params, mask) {
    return ajaxGet(path.getAllRenewList, params, mask)
  },
  saveChargingStrategy: function (params, mask) {
    return ajaxPost(path.saveChargingStrategy, params, mask)
  },
  editChargingStrategy: function (params, mask) {
    return ajaxPost(path.editChargingStrategy, params, mask)
  },
  enableDisableChargingStrategy: function (params, mask) {
    return ajaxPost(path.enableDisableChargingStrategy, params, mask)
  },
  delChargingStrategy: function (params, mask) {
    return ajaxPost(path.delChargingStrategy, params, mask)
  },
  queryAllChargingStrategy: function (params, mask) {
    return ajaxGet(path.queryAllChargingStrategy, params, mask)
  },
  queryChargingStrategyList: function (params, mask) {
    return ajaxGet(path.queryChargingStrategyList, params, mask)
  },
  queryVersionCommodityByVersion: function (params, mask) {
    return ajaxGet(path.queryVersionCommodityByVersion, params, mask)
  },
  saveCommodityByVersion: function (params, mask) {
    return ajaxPost(path.saveCommodityByVersion, params, mask)
  },
  queryFormalUserListByCSID: function (params, mask) {
    return ajaxGet(path.queryFormalUserListByCSID, params, mask)
  },
  saveInvite: function (params, mask) {
    return ajaxPost(path.saveInvite, params, mask)
  },
  editInvite: function (params, mask) {
    return ajaxPost(path.editInvite, params, mask)
  },
  delInviteCode: function (params, mask) {
    return ajaxPost(path.delInviteCode, params, mask)
  },
  queryInviteList: function (params, mask) {
    return ajaxGet(path.queryInviteList, params, mask)
  },
  queryFormalUserListByInviteId: function (params, mask) {
    return ajaxGet(path.queryFormalUserListByInviteId, params, mask)
  },
  getAllComponentList: function (params, mask) {
    return ajaxGet(path.getAllComponentList, params, mask)
  },
  getComponentManageList: function (params, mask) {
    return ajaxGet(path.getComponentManageList, params, mask)
  },
  saveComponentManage: function (params, mask) {
    return ajaxPost(path.saveComponentManage, params, mask)
  },
  updateComponentManage: function (params, mask) {
    return ajaxPost(path.updateComponentManage, params, mask)
  },
  getComponentList: function (params, mask) {
    return ajaxGet(path.getComponentList, params, mask)
  },
  getComponentManageDetail: function (params, mask) {
    return ajaxGet(path.getComponentManageDetail, params, mask)
  },
  delComponentManage: function (params, mask) {
    return ajaxPost(path.delComponentManage, params, mask)
  },
  getEnableComponentManageList: function (params, mask) {
    return ajaxGet(path.getEnableComponentManageList, params, mask)
  },
  findThirdParty: function (params, mask) {
    return ajaxGet(path.findThirdParty, params, mask)
  },
  saveThirdParty: function (params, mask) {
    return ajaxPost(path.saveThirdParty, params, mask)
  },
  deleteThirdParty: function (params, mask) {
    return ajaxPost(path.deleteThirdParty, params, mask)
  },
  /* ************************  应用管理  ***************************** */
  queryApplicationList: function (params, mask) {
    return ajaxGet(path.queryApplicationList, params, mask)
  },
  findApplicationById: function (params, mask) {
    return ajaxGet(path.findApplicationById, params, mask)
  },
  deleteApplication: function (params, mask) {
    return ajaxPost(path.deleteApplication, params, mask)
  },
  approvalApplication: function (params, mask) {
    return ajaxPost(path.approvalApplication, params, mask)
  },
  queryReleaseApplicationList: function (params, mask) {
    return ajaxGet(path.queryReleaseApplicationList, params, mask)
  },
  editNonsuchApplication: function (params, mask) {
    return ajaxPost(path.editNonsuchApplication, params, mask)
  },
  editApplicationNumber: function (params, mask) {
    return ajaxPost(path.editApplicationNumber, params, mask)
  },
  updateApplication: function (params, mask) {
    return ajaxPost(path.updateApplication, params, mask)
  },
  updateApplicationVersion: function (params, mask) {
    return ajaxPost(path.updateApplicationVersion, params, mask)
  },
  deleteReleaseApplication: function (params, mask) {
    return ajaxPost(path.deleteReleaseApplication, params, mask)
  },
  updateNonsuchApplication: function (params, mask) {
    return ajaxPost(path.updateNonsuchApplication, params, mask)
  },
  queryNonsuchApplicationList: function (params, mask) {
    return ajaxGet(path.queryNonsuchApplicationList, params, mask)
  },
  removeNonsuchApplication: function (params, mask) {
    return ajaxPost(path.removeNonsuchApplication, params, mask)
  },
  queryAssemblyAndVersion: function (params, mask) {
    return ajaxGet(path.queryAssemblyAndVersion, params, mask)
  },
  editApplication: function (params, mask) {
    return ajaxPost(path.editApplication, params, mask)
  },
  applicationChargeBillRecordList: function (params, mask) {
    return ajaxGet(path.applicationChargeBillRecordList, params, mask)
  },
  updatePaymentStatusById: function (params, mask) {
    return ajaxGet(path.updatePaymentStatusById, params, mask)
  },
  applicationChargeBillRecordExport: function (params, mask) {
    return ajaxGet(path.applicationChargeBillRecordExport, params, mask)
  },
  appClassifyList: function (params, mask) {
    return ajaxGet(path.appClassifyList, params, mask)
  },
  appClassifySave: function (params, mask) {
    return ajaxPost(path.appClassifySave, params, mask)
  },
  appClassifyDel: function (params, mask) {
    return ajaxPost(path.appClassifyDel, params, mask)
  },
  appClassifySort: function (params, mask) {
    return ajaxPost(path.appClassifySort, params, mask)
  },
  queryAuthorizationCodeUserCountList: function (params, mask) {
    return ajaxPost(path.queryAuthorizationCodeUserCountList, params, mask)
  },
  saveAuthorizationCode: function (params, mask) {
    return ajaxPost(path.saveAuthorizationCode, params, mask)
  },
  deleteAuthorizationCode: function (params, mask) {
    return ajaxPost(path.deleteAuthorizationCode, params, mask)
  },
  /** ************* 发布管理START ***********************************************/
  addReleaseNotice: function (params, mask) {
    return ajaxPost(path.addReleaseNotice, params, mask)
  },
  modifyReleaseNotice: function (params, mask) {
    return ajaxPost(path.modifyReleaseNotice, params, mask)
  },
  deleteReleaseNotice: function (params, mask) {
    return ajaxPost(path.deleteReleaseNotice, params, mask)
  },
  queryReleaseNoticeList: function (params, mask) {
    return ajaxGet(path.queryReleaseNoticeList, params, mask)
  },
  /** ************* 发布管理END ***********************************************/

  /** ************* 新闻中心START ***********************************************/
  newsQueryNewType: function (params, mask) {
    return ajaxGet(path.newsQueryNewType, params, mask)
  },
  newsQueryNewsList: function (params, mask) {
    return ajaxGet(path.newsQueryNewsList, params, mask)
  },
  newsDeleteNews: function (params, mask) {
    return ajaxPost(path.newsDeleteNews, params, mask)
  },
  newsUpdateNewsStatus: function (params, mask) {
    return ajaxPost(path.newsUpdateNewsStatus, params, mask)
  },
  newsAddNews: function (params, mask) {
    return ajaxPost(path.newsAddNews, params, mask)
  },
  newsUpdateNews: function (params, mask) {
    return ajaxPost(path.newsUpdateNews, params, mask)
  },
  newsAddNewsType: function (params, mask) {
    return ajaxPost(path.newsAddNewsType, params, mask)
  },
  newsUpdateNewsTypeSort: function (params, mask) {
    return ajaxPost(path.newsUpdateNewsTypeSort, params, mask)
  },
  topNews: function (params, mask) {
    return ajaxPost(path.topNews, params, mask)
  },
  newsUpdateNewsType: function (params, mask) {
    return ajaxPost(path.newsUpdateNewsType, params, mask)
  },
  newsDeleteNewsType: function (params, mask) {
    return ajaxPost(path.newsDeleteNewsType, params, mask)
  },
  webNewsQueryNewsDetail: function (params, mask) {
    return ajaxGet(path.webNewsQueryNewsDetail, params, mask)
  },
  /** ************* 新闻中心END ***********************************************/

  /** ************* 帮助中心START *********************************************/
  helpCenterAddMenu: function (params, mask) {
    return ajaxPost(path.helpCenterAddMenu, params, mask)
  },
  updateMenu: function (params, mask) {
    return ajaxPost(path.updateMenu, params, mask)
  },
  queryMenuList: function (params, mask) {
    return ajaxGet(path.queryMenuList, params, mask)
  },
  queryDocList: function (params, mask) {
    return ajaxGet(path.queryDocList, params, mask)
  },
  deleteMenu: function (params, mask) {
    return ajaxPost(path.deleteMenu, params, mask)
  },
  swapMenuSort: function (params, mask) {
    return ajaxPost(path.swapMenuSort, params, mask)
  },
  addDoc: function (params, mask) {
    return ajaxPost(path.addDoc, params, mask)
  },
  updateDoc: function (params, mask) {
    return ajaxPost(path.updateDoc, params, mask)
  },
  updateDocSort: function (params, mask) {
    return ajaxPost(path.updateDocSort, params, mask)
  },
  deleteDoc: function (params, mask) {
    return ajaxPost(path.deleteDoc, params, mask)
  },
  /** ************* 帮助中心END ***********************************************/

  /** ************************** 平台管理 **********************************/
  queryUserList: function (params, mask) {
    return ajaxGet(path.queryUserList, params, mask)
  },
  savaUser: function (params, mask) {
    return ajaxPost(path.savaUser, params, mask)
  },
  editUser: function (params, mask) {
    return ajaxPost(path.editUser, params, mask)
  },
  delUser: function (params, mask) {
    return ajaxPost(path.delUser, params, mask)
  },
  enableDisableUser: function (params, mask) {
    return ajaxPost(path.enableDisableUser, params, mask)
  },
  editPwd: function (params, mask) {
    return ajaxPost(path.editPwd, params, mask)
  },
  queryFchBtnAuth: function (params, mask) {
    return ajaxGet(path.queryFchBtnAuth, params, mask)
  },
  queryRoleList: function (params, mask) {
    return ajaxGet(path.queryRoleList, params, mask)
  },
  queryRoleUser: function (params, mask) {
    return ajaxGet(path.queryRoleUser, params, mask)
  },
  queryRoleAuth: function (params, mask) {
    return ajaxGet(path.queryRoleAuth, params, mask)
  },
  modifyAuthByRole: function (params, mask) {
    return ajaxPost(path.modifyAuthByRole, params, mask)
  },
  addRole: function (params, mask) {
    return ajaxPost(path.addRole, params, mask)
  },
  modifyRole: function (params, mask) {
    return ajaxPost(path.modifyRole, params, mask)
  },
  deleteRole: function (params, mask) {
    return ajaxPost(path.deleteRole, params, mask)
  },
  queryInitRoleAuth: function (params, mask) {
    return ajaxGet(path.queryInitRoleAuth, params, mask)
  },
  getUserByRole: function (params, mask) {
    return ajaxPost(path.getUserByRole, params, mask)
  },
  savaRoleAccount: function (params, mask) {
    return ajaxPost(path.savaRoleAccount, params, mask)
  },
  queryRecordList: function (params, mask) {
    return ajaxGet(path.queryRecordList, params, mask)
  },
  saveVersionInfo: function (params, mask) {
    return ajaxPost(path.saveVersionInfo, params, mask)
  },
  updateVersionInfo: function (params, mask) {
    return ajaxPost(path.updateVersionInfo, params, mask)
  },
  delVersionInfo: function (params, mask) {
    return ajaxPost(path.delVersionInfo, params, mask)
  },
  getVersionList: function (params, mask) {
    return ajaxGet(path.getVersionList, params, mask)
  },
  getLocalMonitorList: function (params, mask) {
    return ajaxGet(path.getLocalMonitorList, params, mask)
  },
  startMonitorCompany: function (params, mask) {
    return ajaxPost(path.startMonitorCompany, params, mask)
  },
  dataEmbeddingpointExport: function (params, mask) {
    return ajaxPost(path.dataEmbeddingpointExport, params, mask)
  },
  queryDataembeddingpointList: function (params, mask) {
    return ajaxGet(path.queryDataembeddingpointList, params, mask)
  },
  getBusinessCardList: function (params, mask) {
    return ajaxGet(path.getBusinessCardList, params, mask)
  },
  enableDisableCard: function (params, mask) {
    return ajaxPost(path.enableDisableCard, params, mask)
  }
}
// 两个都执行完成才执行
// asyncAjax: function (ajax_one, ajax_two) {
//   axios.all()
// }

export {HTTPServer, baseURL, baseURL2, ajaxGetRequest, ajaxPostRequest}



// WEBPACK FOOTER //
// ./src/common/js/ajax.js